module.exports = __webpack_public_path__ + "assets/img/is-top-neutral.4eff330e.svg";